/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nudge_Enable_Notetaker_MessageInputs */



/**
* | output |
* | --- |
* | "Turn the notetaker on for my next conversation." |
*
* @param {Nudge_Enable_Notetaker_MessageInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const nudge_enable_notetaker_message = /** @type {((inputs?: Nudge_Enable_Notetaker_MessageInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nudge_Enable_Notetaker_MessageInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Zet de notetaker aan voor mijn volgende gesprek.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activez le notetaker pour ma prochaine conversation.")
	return /** @type {LocalizedString} */ ("Turn the notetaker on for my next conversation.")
});